import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const state = {
	token: window.sessionStorage.getItem('token'),
	role: window.sessionStorage.getItem('role'),
    userCode: window.sessionStorage.getItem('userCode'),
    language: window.sessionStorage.getItem('language') || '1',//  默认中文
}

const mutations = {
    // 语言选择
	SET_LANGUAGE: (state, data) => {
        state.language = data;
        window.sessionStorage.setItem('language', data)
    },
    // 登录信息
	SET_TOKEN: (state, data) => {
        state.token = data;
        window.sessionStorage.setItem('token', data)
    },
    // 角色
    SET_ROLE: (state, data) => {
        state.role = data;
        window.sessionStorage.setItem('role', data)
    },
    // 用户编码
    SET_USERCODE: (state, data) => {
        state.userCode = data;
        window.sessionStorage.setItem('userCode', data)
    },
    SET_UserEmail: (state, data) => {
        state.userEmail = data;
        window.sessionStorage.setItem('userEmail', data)
    },
    SET_WalletAddres: (state, data) => {
        state.walletAddress = data;
        window.sessionStorage.setItem('walletAddress', data)
    },

    // 头部菜单导航栏
    SET_ActivePath: (state, data) => {
        state.activePath = data;
        window.sessionStorage.setItem('activePath', data)
    },

    // Mining订单信息
    SET_Service_Package_Code: (state, data) => {
        state.servicePackageCode = data;
        window.sessionStorage.setItem('servicePackageCode', data)
    },
    SET_Esyimated_Profit: (state, data) => {
        state.esyimatedProfit = data;
        window.sessionStorage.setItem('esyimatedProfit', data)
    },
    SET_Release_Duration: (state, data) => {
        state.releaseDuration = data;
        window.sessionStorage.setItem('releaseDuration', data)
    },
    SET_Daily_Profit: (state, data) => {
        state.dailyProfit = data;
        window.sessionStorage.setItem('dailyProfit', data)
    },
    SET_Deposit: (state, data) => {
        state.deposit = data;
        window.sessionStorage.setItem('deposit', data)
    },
    SET_Product_Price: (state, data) => {
        state.productPrice = data;
        window.sessionStorage.setItem('productPrice', data)
    },
    SET_Type: (state, data) => {
        state.type = data;
        window.sessionStorage.setItem('type', data)
    },
    SET_OrderCode: (state, data) => {
        state.orderCode = data;
        window.sessionStorage.setItem('orderCode', data)
    }
}

export default new Vuex.Store({
    state,
    mutations
  });